// Import Swiper and modules
import Swiper from "swiper/bundle";

export const locations = () => {
  const $locationSections = document.querySelectorAll("section.locations");
  if ($locationSections) {
    $locationSections.forEach(($locationSection) => {
      const $contentsMobileSwiper = $locationSection.querySelector(
        ".contents__mobile .mobile__swiper.swiper"
      );
      if ($contentsMobileSwiper) {
        const swiperConfig = {
          direction: "horizontal",
          speed: 1000,
          slidesPerView: 1.1,
          slidesPerGroup: 1,
          spaceBetween: 12,
        };
        const swiperObject = new Swiper($contentsMobileSwiper, swiperConfig);
      }
    });
  }
};

export default locations;
